import { ICarouselPrincipal } from "@/types/app";
import { getImageUrl } from "@/utils/global";
import { isInternalLink } from "@/utils/linkValidator";
import { useState } from "react";
import ExternalLinkModal from "@/Components/modals/ExternalLinkModal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Gift } from "lucide-react";

export default function BeneficiosCliente({
    promocionesSecundarias,
}: {
    promocionesSecundarias: ICarouselPrincipal[];
}) {
    const [externalLinkModalOpen, setExternalLinkModalOpen] = useState(false);
    const [pendingExternalUrl, setPendingExternalUrl] = useState<string>('');

    if (!promocionesSecundarias || promocionesSecundarias.length === 0) return null;

    const handleLinkClick = (url?: string | null) => {
        if (!url || url.trim() === '') return;
        const normalizedUrl = url.trim();
        if (isInternalLink(normalizedUrl)) {
            window.location.href = normalizedUrl;
        } else {
            setPendingExternalUrl(normalizedUrl);
            setExternalLinkModalOpen(true);
        }
    };

    const handleConfirmExternal = () => {
        if (pendingExternalUrl) window.location.href = pendingExternalUrl;
        setExternalLinkModalOpen(false);
        setPendingExternalUrl('');
    };

    return (
        <section className="py-12 md:py-16 bg-white">
            <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
                <div className="flex flex-col items-center text-center mb-10">
                    <div className="flex items-center gap-3 mb-4">
                        <Gift className="w-6 h-6 md:w-8 md:h-8 text-[#790546]" />
                        <h2 className="text-xl md:text-2xl font-bold text-gray-900 tracking-tight text-balance">
                            Beneficios Exclusivos
                        </h2>
                    </div>
                    <p className="text-gray-600 max-w-2xl text-sm md:text-base leading-relaxed px-6 text-balance">
                        Aprovecha nuestras promociones diseñadas especialmente para ti
                    </p>
                    <div className="w-16 h-0.5 bg-[#790546] rounded-full mt-5 mb-0"></div>
                </div>

                <div className="w-full relative px-0 sm:px-4">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={16}
                        slidesPerView={1}
                        centeredSlides={true}
                        pagination={{ clickable: true, dynamicBullets: true }}
                        autoplay={{ delay: 4500, disableOnInteraction: false }}
                        loop={promocionesSecundarias.length > 1}
                        breakpoints={{
                            768: { slidesPerView: 2, spaceBetween: 24, centeredSlides: false },
                            1024: { slidesPerView: 2, spaceBetween: 28, centeredSlides: false },
                        }}
                        className="w-full pb-14"
                    >
                        {promocionesSecundarias.map((promo) => (
                            <SwiperSlide key={promo.id}>
                                <div
                                    onClick={() => handleLinkClick(promo.link)}
                                    className="cursor-pointer transition-transform duration-300 transform hover:-translate-y-1 block w-full px-2 md:px-0"
                                >
                                    <img
                                        src={getImageUrl(promo.ruta)}
                                        loading="lazy"
                                        className="w-full h-auto rounded-xl shadow-sm hover:shadow-lg transition-shadow border border-gray-100 object-contain mx-auto max-h-[400px]"
                                        alt={promo.nombre_promo || `Beneficio ${promo.id}`}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>

            <ExternalLinkModal
                isOpen={externalLinkModalOpen}
                onClose={() => setExternalLinkModalOpen(false)}
                onConfirm={handleConfirmExternal}
                url={pendingExternalUrl}
            />
        </section>
    );
}
